import * as React from "react";

const Twitter = (props) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M25.6133 5.3483C24.7087 5.74913 23.737 6.01996 22.7154 6.14238C23.7695 5.51166 24.5581 4.51897 24.9341 3.34955C23.9437 3.93779 22.8598 4.35184 21.7296 4.57371C20.9695 3.76215 19.9627 3.22423 18.8656 3.04348C17.7684 2.86272 16.6423 3.04924 15.6621 3.57407C14.6818 4.0989 13.9022 4.93269 13.4444 5.94598C12.9865 6.95926 12.8761 8.09536 13.1301 9.17788C11.1234 9.07713 9.16032 8.55556 7.36826 7.64703C5.57621 6.7385 3.99521 5.4633 2.72789 3.90421C2.29455 4.65171 2.04539 5.51838 2.04539 6.44138C2.0449 7.27229 2.24952 8.09048 2.64109 8.82334C3.03266 9.5562 3.59906 10.1811 4.29005 10.6425C3.48869 10.617 2.705 10.4005 2.00422 10.011V10.076C2.00414 11.2413 2.40726 12.3709 3.14517 13.2729C3.88308 14.1749 4.91034 14.7938 6.05264 15.0246C5.30924 15.2258 4.52984 15.2555 3.7733 15.1113C4.09559 16.114 4.72338 16.9909 5.56878 17.6191C6.41419 18.2474 7.43488 18.5955 8.48797 18.6148C6.70029 20.0182 4.49251 20.7794 2.2198 20.776C1.81722 20.7762 1.41497 20.7526 1.01514 20.7056C3.32207 22.1889 6.00751 22.9761 8.75014 22.973C18.0343 22.973 23.1097 15.2835 23.1097 8.61455C23.1097 8.39788 23.1043 8.17905 23.0946 7.96238C24.0818 7.24844 24.934 6.36435 25.6111 5.35155L25.6133 5.3483Z"
      fill="white"
    />
  </svg>
)
export default Twitter;